import React from "react";

const ArrowUpSFillIcon = () => (
	<g>
		<path d='M12 8L18 14H6L12 8Z' />
	</g>
);

export default ArrowUpSFillIcon;
